import BreadcrumbsMixin from "../../Mixins/BreadcrumbsMixin";
import UserComponentMixin from "../../Mixins/UserComponentMixin";

export default {
  data () {
    return {
      resourceName: "user"
    };
  },

  mixins: [BreadcrumbsMixin, UserComponentMixin]
};
